import { sqrt } from "../math.js";
var sqrt3 = sqrt(3);
export default {
  draw: function draw(context, size) {
    var y = -sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
};